import { apiRequest } from './client';
import type { TestimonialList } from '../types/admin';

export type ListTestimonialsParams = {
  readonly limit?: number;
  readonly offset?: number;
};

export function getTestimonials(
  accessToken: string,
  params: ListTestimonialsParams = {},
): Promise<TestimonialList> {
  const search = new URLSearchParams();
  if (params.limit != null) search.set('limit', String(params.limit));
  if (params.offset != null) search.set('offset', String(params.offset));
  const query = search.toString();
  return apiRequest<TestimonialList>(`/admin/testimonials${query ? `?${query}` : ''}`, {
    token: accessToken,
  });
}
